import { useEffect } from "react";

import useTranslation from "../../hooks/useTranslation";

import TEXT from "../../config/text";

import IMAGES from "../../config/images";

export default function PaymentErrorPage() {
    const translation = useTranslation();

    const handleText = (text) => {
        if (translation?.pages?.payment_error?.[text]) {
            return translation?.pages?.payment_error?.[text];
        }

        return TEXT?.pages?.payment_error?.[text];
    };

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }, []);

    return (
        <div
            style={{
                width: "100%",
                height: "calc(100vh - 136px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <img src={IMAGES.ERROR} />

            <h2 style={{ marginTop: 30, color: "white" }}>{handleText("message")}</h2>
        </div>
    );
}
